export const BORDER_SKETCH_KEY = 'sketchStyle';

/**
 * 草绘类型
 */
export enum BorderSketchType {
    /**
     * 无
     */
    NONE = 'lineSketchNone',
    /**
     * 曲形
     */
    CURVED = 'lineSketchCurved',
    /**
     * 手绘
     */
    FREEHAND = 'lineSketchFreehand',
    /**
     * 自由曲线
     */
    SCRIBBLE = 'lineSketchScribble',
}
